import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Scharnier from "../../doors/scharnier";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleScharnierSinglePanelSingleScharnierProps
  extends ConfigurationProps {}
const SingleScharnierSinglePanelSingleScharnier: React.FC<
  SingleScharnierSinglePanelSingleScharnierProps
> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SingleScharnierSinglePanelSingleScharnierProps) => {
  const position0 = new Vector3(-0.458, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1, position2]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
      <Scharnier
        materials={materials}
        position={positions[2]}
        index={2}
        kozijnSettings={doorSettings?.tertiary?.kozijnSettings}
        frameSettings={doorSettings?.tertiary?.frameSettings}
        lockSettings={doorSettings?.tertiary?.lockSettings}
      />
    </group>
  );
};

export default SingleScharnierSinglePanelSingleScharnier;
